import React from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '@iconify/react/dist/iconify.js';

const PortalModuleCard = ({ module }) => {
  const { title, subtitle, description, icon, color, available, to } = module;

  const content = (
    <>
      <div className={`portal-module-card__icon portal-module-card__icon--${color}`}>
        <Icon icon={icon} />
      </div>
      <div className="portal-module-card__body">
        <div className="d-flex align-items-center gap-2 mb-1">
          <h3 className="portal-module-card__title mb-0">{title}</h3>
          {!available && (
            <span className="badge bg-neutral-200 text-secondary-light text-xs">
              Bientôt disponible
            </span>
          )}
        </div>
        <p className="portal-module-card__subtitle mb-2">{subtitle}</p>
        <p className="portal-module-card__description mb-0">{description}</p>
      </div>
      {available && (
        <div className="portal-module-card__action">
          <Icon icon="solar:arrow-right-linear" className="text-xl" />
        </div>
      )}
    </>
  );

  if (available && to) {
    return (
      <Link to={to} className="portal-module-card portal-module-card--active">
        {content}
      </Link>
    );
  }

  return (
    <div className="portal-module-card portal-module-card--disabled" aria-disabled="true">
      {content}
    </div>
  );
};

export default PortalModuleCard;
